import { Component, Input, OnDestroy } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { from, mergeMap, ReplaySubject, takeUntil } from 'rxjs';
import { sequence } from '0xsequence';

import { BadgesService } from '../../../services/badges.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-badge-detail',
  templateUrl: './badge-detail.page.html',
  styleUrls: ['./badge-detail.page.scss'],
})
export class BadgeDetailPage implements OnDestroy {
  @Input() id: string;
  @Input() icon: string;
  @Input() name: string;
  @Input() description: string;
  @Input() conqueredAt: Date;
  @Input() tokenize: boolean;
  @Input() tokenUrl: string;

  loading?: boolean;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private badgesService: BadgesService,
    public modalController: ModalController,
    private toastController: ToastController
  ) {}

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  async handleButtonClick() {
    if (this.tokenUrl) {
      window.open(this.tokenUrl, '_blank');
    } else {
      this.claimBadge();
    }
  }

  private claimBadge() {
    this.loading = true;

    from(this.getWalletAddress())
      .pipe(
        takeUntil(this.destroyed$),
        mergeMap((walletAddress) =>
          this.badgesService.claimBadge(this.id, walletAddress)
        )
      )
      .subscribe({
        next: async () => {
          this.loading = false;

          await Promise.all([
            this.showToast('primary', 'Sua medalha está a caminho!'),
            this.modalController.dismiss(true),
          ]);
        },
        error: async (error) => {
          console.error('Erro no claim.', error);

          this.loading = undefined;

          await this.showToast('danger', 'Erro ao processar medalha.');
        },
      });
  }

  private async getWalletAddress() {
    const wallet = await sequence.initWallet(
      environment.production ? 'polygon' : 'mumbai'
    );

    const connection = await wallet.connect({
      app: 'Brivia: Passaporte Digital',
      askForEmail: false,
      settings: {
        bannerUrl: `${window.location.origin}/assets/icons/banner-1200x400.png`,
        signInOptions: ['google'],
        theme: 'light',
      },
    });

    if (connection.connected) {
      return await wallet.getAddress();
    }

    throw new Error('User is not connected to wallet.');
  }

  private async showToast(color: string, message: string) {
    const toast = await this.toastController.create({
      color,
      duration: 5000,
      message,
    });

    await toast.present();
  }
}
